import { jsx as i } from "react/jsx-runtime";
import e from "classnames";
import a from "../../utils/colors.js";
import { f } from "../../styled-qu50FBLM.mjs";
import { Svg as s, Path as c } from "./Elements.js";
const g = ({
  className: r = "",
  fill: o = a.white,
  viewBox: l = "0 0 30 30",
  $cssHelper: m = f,
  focusable: t
}) => /* @__PURE__ */ i(
  s,
  {
    className: e({ [r]: !!r }),
    viewBox: l,
    $cssHelper: m,
    role: "img",
    focusable: !!t,
    "aria-hidden": !t,
    children: /* @__PURE__ */ i(
      c,
      {
        color: o,
        fill: o,
        d: "M15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0zm2.713 11l-1.374 1.282 1.942 1.812H8v1.812h10.28l-1.94 1.812L17.712 19 22 15l-4.287-4z",
        $transition: "fill 0.1s ease-in-out"
      }
    )
  }
);
export {
  g as default
};
